<template>
<div :id="tabid" class="song-list-container" v-observe-visibility="visibilityChanged">
    <header-trending v-if="header == 'trending'" class="row m-h--5 m-b-0 m-t-8"></header-trending>

    <div class="row" v-if="header == 'search'">
        <div class="col-xs-12">
            <div class="search-input">
                <input type="text" class="browser-default dark" placeholder="Search artist, title ..." v-model="searchText">
                <span v-show="!searchText.length">
                    <i class="iconify icon:ic:outline-search"></i>
                </span>
                <span v-show="searchText.length" @click="cancelSearch">
                    <i class="iconify icon:mdi:close-circle"></i>
                </span>   
            </div>
        </div>
    </div>

    <div class="row song-list m-h--5" v-if="layout == 'default'">
        <div class="col-xs-12">
            <div class="row">
                <song-widget v-if="i > Math.round(currentWidget/8)*8 - 10 && i < Math.round(currentWidget/8)*8 + 10" v-for="(song, i) in songs" :key="i" :index="i+1" :song="song" :layout="layout" :filter-key="filterKey" :filter-value="filterValue" :showData="showData" :origin="origin" :class="elemClass(i)"></song-widget>
                <div v-else class="song-widget placeholder col-xs-6 p-h-5 no-transition">
                    <div class="inner-container"><loader size="100px"></loader></div>
                </div>
                
                <div v-if="loading && !fetchedAllSongs && !songs.length">
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="100px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="100px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="100px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="100px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5 last last-loaded">
                        <div class="inner-container"><loader size="100px"></loader></div>
                    </div>
                </div>

                <div v-show="!fetchedAllSongs && songs.length" class="song-widget preloader col-xs-6 p-h-5">
                    <loader size="128px" :color="loader"></loader>
                </div>                                
            </div>
        </div>
    </div>

    <div class="row song-list-rows m-h--5" :class="layout" v-else>
        <div class="col-xs-12">
            <div class="row">
                <song-line v-for="(song, i) in songs" :key="i" :index="i+1" :song="song" :privacy="requestData.privacy" :layout="layout" :filterKey="filterKey" :filterValue="filterValue" :showData="showData" :origin="origin" :class="elemClass(i)"></song-line>
                
                <div class="song-widget preloader col-xs-12" v-show="!fetchedAllSongs">
                    <loader size="128px"></loader>
                </div>

                <div class="col-xs-12 text-center" v-show="fetchedAllSongs && songs.length">
                    <br><i class="iconify icon:uil:grip-horizontal-line text-disabled" data-height="24"></i>
                </div>

                <div class="col-xs-12 text-center no-results" v-show="fetchedAllSongs && !songs.length">
                    <span class="iconify icon:ic:baseline-music-off" data-height="70"></span>
                    <br>
                    <b>NO SONGS FOUND</b><br>
                    Try changing filters or search term
                </div>
            </div>
        </div>
    </div>    
</div>
</template>

<script>
import filtersFactory from '../../Filters/Factory';
import { ObserveVisibility } from 'vue-observe-visibility';

export default {
    components: {
        'header-trending': require('@/components/Song/Widget/HeaderTrending.vue').default,
        'song-widget': require('@/components/Song/Widget/Default.vue').default,
        'song-line': require('@/components/Song/Widget/Line.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    props: {
        tabid: { default: null },
        layout: { default: 'default' },
        header: { default: null },
        showData: { default: null },
        origin: { default: '< not set >' },
        loader: { default: 'ripple'},
        playlistName: { default: 'Playlist' },
        endpoint: { default: App.restApi + '/api/song/search', },
        filter: { default: false, },
        requestData: { default: () => { return {}; }, },
        appendPage: { default: false, },
        userUploadsPage: { default: false, },
        t: {default: 1,}
    },

    data() {
        return {
            reqID: 0,
            songs: [],
            page: 1,
            loading: true,
            init: false,
            searchText: '',
            searchDelay: false,
            fetchedAllSongs: false,
            scrollPosition: {
                top: 0,
                left: 0,
            },
            // The two are used only by line widget
            filterKey: 'order_by_publish_date',
            filterValue: 'desc',
            lineShowedAtLeastOnce: App.user.settings.use_line_widget ? false : true,

            showOptions: false,
            currentWidget: 0,
        }
    },

    activated(){
        var wW = $(`#${this.tabid} .song-list .song-widget`).width() + 10;
        
        $(`#${this.tabid} .song-list`).scrollLeft(this.scrollPosition.left);
        // this.currentWidget = Math.round(this.scrollPosition.left / wW);

        $(`#${this.tabid} .song-list-rows`).scrollTop(this.scrollPosition.top);
        $(`#${this.tabid} .song-list-rows`).scrollLeft(this.scrollPosition.left);
    },

    mounted() {
        if (this.filter == 'ReceivedAsTrending'){
            this.filterKey = 'order_by_financial';
            this.filterValue = 'youtube.daily.desc';
        }

        if (this.requestData.order_by_evolution){
            this.filterKey = 'order_by_evolution';
            this.filterValue = this.requestData.order_by_evolution;
        }

        if (this.requestData.order_by_financial){
            this.filterKey = 'order_by_financial';
            this.filterValue = this.requestData.order_by_financial;
        }

        if (this.requestData.order_by_provider_views){
            this.filterKey = 'order_by_provider_views';
            this.filterValue = this.requestData.order_by_provider_views;
        }

        this.getSongs();
        this.listenForEvents();

        var that = this;
        var scrollTimeout = false;
        var wW = $(`#${this.tabid} .song-list .song-widget`).width() + 10;

        //horizontal
        $(`#${this.tabid} .song-list`).on('touchstart', function() {
            $(this).stop(true, true);
        }).on('scroll', function() {
            that.scrollPosition.left = $(this)[0].scrollLeft;
            that.currentWidget = Math.round($(this)[0].scrollLeft / wW);

            if($(this).scrollLeft() + $(this).innerWidth() >= $(this)[0].scrollWidth - 5) {
                if (that.fetchedAllSongs || that.loading) {
                    return;
                }

                $(this).animate({ scrollLeft: $(this)[0].scrollWidth }, 500);
                that.getSongs(true);
            }

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                $(this).stop(true, true).animate({ scrollLeft: that.currentWidget * wW }, 250);
            }, 250);
        });


        //vertical
        $(`#${this.tabid} .song-list-rows`).on('scroll', function() {
            if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 50) {
                if (that.fetchedAllSongs || that.loading) {
                    return;
                }

                $(this).animate({ scrollTop: $(this)[0].scrollHeight }, 500);
                that.getSongs(true);
            }

            that.scrollPosition.top = $(this).scrollTop();
            that.scrollPosition.left = $(this).scrollLeft();            
        })
    },

    methods: {
        getSongs(append = false) {
            this.reqID++;
            var reqID = this.reqID * 1;
            
            if (!append){
                $(`#${this.tabid} .song-widget`).addClass('no-transition');
                $('.song-list').scrollLeft(0);
                this.songs = [];
            }

            this.loading = true;
            this.fetchedAllSongs = false; // we update the flag after getting confirmation from the server

            this.$http.post(this.getEndpoint, this.getRequestData, {timeout: this.songs.length ? 10000 : 0}).then((success) => {
                if (reqID < this.reqID) return;

                this.page += 1;
                this.loading = false;
                $(`#${this.tabid} .song-widget`).removeClass('no-transition');

                if (success.data.data.length < this.getRequestData.take) {
                    this.fetchedAllSongs = true;
                }

                if (append == false) {
                    this.songs = success.data.data;
                    this.init = true;
                }else{
                    this.songs = this.buildSongsArray(success.data.data);
                }
            }, (err) => {
                //if error.status == 0 .. it;s timeout
                var wW = $(`#${this.tabid} .song-list .song-widget`).width() + 10;
                $(`#${this.tabid} .song-list`).animate({ scrollLeft: this.currentWidget * wW - wW }, 250);  

                setTimeout(() => { this.loading = false; }, 350);
            });
        },
 
        buildSongsArray(newSongs) {

            // Get index of last group displayed
            var lastGroupIndex = this.songs.length - 1;
            // Get separator of last group displayed
            var lastGroupSeparator = this.songs[lastGroupIndex][0];

            // Get separator of the new group from http request
            var newGroupSeparator = false;
            if ((typeof newSongs != 'undefined')
                && (typeof newSongs[0] != 'undefined')
            ){
                newGroupSeparator = newSongs[0][0];
            }

            // If separators are the same, combine the groups
            if (lastGroupSeparator && (lastGroupSeparator === newGroupSeparator)) {
                for (var i = 1; i < newSongs[0].length; i++) {
                    this.songs[lastGroupIndex].push(newSongs[0][i]);
                }
                if (newSongs.length > 1) {
                    var songs = [];
                    for (var j = 1; j < newSongs.length; j++) {
                        songs.push(newSongs[j]);
                    }
                    return this.songs.concat(songs);
                }
                return this.songs;
            }

            return this.songs.concat(newSongs);
        },

        loadMore() {
            this.getSongs(true);
        },

        visibilityChanged(isVisible, entry){
            if (isVisible){
                $(`#${this.tabid} .song-list`).scrollLeft(this.scrollPosition.left);
            }
        },

        elemClass(i){
            var c = []; 

            if (i < this.songs.length - (this.requestData.take ? this.requestData.take : 10)) c.push('no-transition');
            if (this.songs.length == i + 1){
                c.push('last');
                if (this.fetchedAllSongs) c.push('last-loaded');
            }

            return c.join(" ");
        },
 
        listenForEvents() {
            this.$on('lineFilterUpdated', (filter) => {
                this.page = 1;
                this.filterKey = filter.key;
                this.filterValue = filter.value;

                this.$nextTick(() => {
                    this.getSongs();
                })
            });

            this.$on('trendingFilterUpdated', (filter) => {
                this.page = 1;
                this.filterValue = filter;

                this.$nextTick(() => {
                    this.getSongs();
                })
            });


            this.$on('lineRefresh', () => {
                this.songs = $.grep(this.songs, function (song, i) {
                    return (typeof song.reviewType === 'undefined' && App.user.songs_of_blocked_users.indexOf(song.id) == -1 );
                });
            });

            this.$root.$on('reviewSong', (songId, review) => {
                $.each(this.songs, function(i, song) {
                    if (song.id == songId){
                        song.reviewType = review;
                    }
                })
            });

            this.$on('play-all', (startFrom = 0) => {
                // if (App.player.playlist.name == this.playlistName && App.player.playlist.data.playlists == this.getRequestData.playlists){
                //     this.$root.$emit('playerAction', 'play');
                //     console.log( 'play' );
                // }else{
                //     this.$root.$emit('loadPlaylist', this.endpoint, $.extend({}, this.getRequestData), this.playlistName, startFrom);
                //     console.log( 'load & play' );
                // }

                this.$root.$emit('mp-load-playlist', this.endpoint, $.extend({}, this.getRequestData), this.playlistName, startFrom, this.songs);
                console.log( 'load & play' );                
            })

            this.$root.$on('reloadSongsList', () => {
                this.init = false;
                this.page = 1;
                this.getSongs();
            });

            this.$root.$on('pickUpdated', (artist_pick, uploader_id) => {
                var i;
                for (i = this.songs.length - 1; i >= 0; --i) {
                    if (this.songs[i].uploader_id == uploader_id){
                        if (artist_pick != 'blocked'){
                            this.songs[i].artist_pick = artist_pick;
                        }else{
                            this.songs.splice(i, 1);
                        }
                    }
                }
            });            
        },

        cancelSearch(){
            $('.search-input').blur();
            this.searchText = '';
        },        
    },

    computed: {
        /**
         * Return complete object with request data.
         */
        getRequestData() {
            // If there is a filter, parse request data to the filter
            if (this.filter) {
                // Filter with all parameters is returned
                var filters = filtersFactory(this.filter, this.getAppendedParameters).get();

                filters['add_separator'] = '';
                filters['order_recent_by_publish_date'] = false;
                filters['order_recent_by_review_month'] = false;
                filters['favorites_first'] = false;
                filters['order_by_evolution'] = false;
                filters['order_by_financial'] = false;

                filters[this.filterKey] = this.filterValue;

                if (this.searchText.length){
                    filters['name'] = this.searchText;
                }
                return filters;
            }

            // If there is no filter, just return the request data
            return this.requestData;
        },

        getEndpoint() {
            if (this.appendPage) {
                var endpoint = this.endpoint + '?page=' + this.page;

                // Require for uploaded songs list.
                if (this.userUploadsPage && (!this.useLine && this.lineShowedAtLeastOnce)) {
                    endpoint += '&add_separator=song_published_at';
                }

                this.lineShowedAtLeastOnce = true;
                return endpoint;
            }

            this.lineShowedAtLeastOnce = true;
            return this.endpoint;
        },

        getAppendedParameters() {
            var parameters = {
                'page': this.page,
            };

            return Object.assign(parameters, this.requestData);
        }
    },

    beforeDestroy() {
        $(`#${this.tabid}`).off('scroll');
        this.$root.$off(['reloadSongsList', 'reviewSong']);
        this.$off(['lineFilterUpdated', 'lineRefresh', 'playAll']);
    },

    watch: {
        requestData: {
            handler() {
                if (this.requestData.order_by_evolution){
                    this.filterKey = 'order_by_evolution';
                    this.filterValue = this.requestData.order_by_evolution;
                }

                if (this.requestData.order_by_financial){
                    this.filterKey = 'order_by_financial';
                    this.filterValue = this.requestData.order_by_financial;
                }

                if (this.requestData.order_by_provider_views){
                    this.filterKey = 'order_by_provider_views';
                    this.filterValue = this.requestData.order_by_provider_views;
                }

                this.page = 1;
                this.$nextTick(() => {
                    this.getSongs();
                })
            },
            deep: true
        },

        searchText(){
            clearTimeout(this.searchDelay);

            this.searchDelay = setTimeout(() => {
                this.page = 1;
                this.getSongs();

                if (App.allowGtag) gtag('event', 'search_song', {
                    'event_category' : this.origin.split(".")[0],
                    'event_label' : `Search song in ${ this.origin.split(".")[1] }`
                });                
            }, 750);
        },

        // "requestData.order_by_financial"() {
        //     this.page = 1;
        //     this.$nextTick(() => {
        //         this.getSongs();
        //     })
        // },

        // "requestData.order_by_evolution"() {
        //     this.page = 1;
        //     this.$nextTick(() => {
        //         this.getSongs();
        //     })
        // },


        // widget(widget) {
        //     console.log('widget changed');
        //     this.$nextTick(() => {
        //         this.getSongs();
        //     });
        // }
    },
}
</script>
